export const GLOBAL_MODAL_OPEN = 'modal/GLOBAL_MODAL_OPEN';
export const GLOBAL_MODAL_CLOSE = 'modal/GLOBAL_MODAL_CLOSE';
export const GLOBAL_MODAL_VISIBILITY = 'modal/GLOBAL_MODAL_VISIBILITY';
export const GLOBAL_MODAL_DATA = 'modal/GLOBAL_MODAL_DATA';
export const GLOBAL_MODAL_OPTIONS = 'modal/GLOBAL_MODAL_OPTIONS';
